export default __webpack_public_path__ + "static/media/26A.b57b9f94.JPG";